import { Skeleton } from '@/components/ui/skeleton';
import type { AdminSenderProxyStatsResponse } from '@/entities/sender.entity';
import { cn } from '@/lib/utils';

function StatRow({ label, value, warn }: { label: string; value: number; warn?: boolean }) {
	return (
		<div className='flex justify-between gap-2 text-sm'>
			<span className='text-muted-foreground'>{label}</span>
			<span className={cn(warn && 'text-destructive font-medium')}>{value}</span>
		</div>
	);
}

function StatsCardSkeleton() {
	return (
		<div className='rounded-lg border border-border bg-muted/20 p-3 flex flex-col gap-2'>
			<Skeleton className='h-4 w-24' />
			{Array.from({ length: 6 }).map((_, index) => (
				<div key={index} className='flex justify-between gap-2'>
					<Skeleton className='h-4 w-20' />
					<Skeleton className='h-4 w-8' />
				</div>
			))}
		</div>
	);
}

export default function SenderProxyStatsCards({ stats }: { stats: AdminSenderProxyStatsResponse | null }) {
	if (!stats) {
		return (
			<div className='grid gap-3 sm:grid-cols-2'>
				<StatsCardSkeleton />
				<StatsCardSkeleton />
			</div>
		);
	}

	const lowAvailable = stats.proxy.available < 3 && stats.proxy.total > 0;

	return (
		<div className='grid gap-3 sm:grid-cols-2'>
			<div className='rounded-lg border border-border bg-muted/20 p-3 flex flex-col gap-2'>
				<p className='text-sm font-medium'>Пул прокси</p>
				<StatRow label='Всего' value={stats.proxy.total} />
				<StatRow label='Доступно' value={stats.proxy.available} warn={lowAvailable} />
				<StatRow label='Назначено' value={stats.proxy.assigned} />
				<StatRow label='Отлежка' value={stats.proxy.resting} />
				<StatRow label='Cooldown' value={stats.proxy.cooldown} />
				<StatRow label='Выведено' value={stats.proxy.retired} />
				{stats.proxy.warnings?.includes('proxy_pool_empty') ? (
					<p className='text-xs text-destructive'>Пул пуст — загрузите txt</p>
				) : null}
				{stats.proxy.warnings?.includes('proxy_pool_exhausted') ? (
					<p className='text-xs text-destructive'>Нет доступных — все назначены</p>
				) : null}
				{stats.proxy.warnings?.includes('proxy_pool_low') ? (
					<p className='text-xs text-amber-600 dark:text-amber-500'>Мало доступных — добавьте прокси</p>
				) : null}
			</div>
			<div className='rounded-lg border border-border bg-muted/20 p-3 flex flex-col gap-2'>
				<p className='text-sm font-medium'>Очередь dispatch</p>
				<StatRow label='В очереди' value={stats.dispatch.queued} />
				<StatRow label='Захвачено' value={stats.dispatch.claimed} />
				<StatRow label='Выполняется' value={stats.dispatch.running} />
			</div>
		</div>
	);
}
